<script setup>
import { computed } from 'vue';

const props = defineProps({
  url: {
    type: String,
    default: '',
  },
  // Already-cached smaller variant, painted underneath so the pane shows the
  // photo immediately while the sharp one streams in.
  lowResUrl: {
    type: String,
    default: '',
  },
  transform: {
    type: Object,
    default: () => ({}),
  },
  label: {
    type: String,
    default: '',
  },
});

const paneStyle = computed(() => ({
  ...props.transform,
  backgroundImage: props.lowResUrl ? `url("${props.lowResUrl}")` : undefined,
  backgroundSize: 'contain',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
}));
</script>

<template>
  <div class="absolute inset-0" :style="paneStyle">
    <img
      :src="url"
      :alt="label"
      class="object-contain w-full h-full"
      draggable="false"
    />
  </div>
</template>
